import { render } from "./DuplicateListAction.vue?vue&type=template&id=30405830"
import script from "./DuplicateListAction.vue?vue&type=script&lang=ts"
export * from "./DuplicateListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script